import type { Pos } from '~platform/entities/pos';

import type { MultiSelectOption } from '~shared/ui/multi-select-filter';

export function getBusinessOptions(onlinePosList: Pos[]): MultiSelectOption[] {
  const labelByMerchant = new Map<string, string>();

  onlinePosList.forEach((pos) => {
    if (!labelByMerchant.has(pos.merchantId)) {
      labelByMerchant.set(pos.merchantId, pos.merchantName);
    }
  });

  return [...labelByMerchant].map(([value, label]) => ({ value, label }));
}

export function getStoreOptions(
  onlinePosList: Pos[],
  selectedMerchantIds: string[]
): MultiSelectOption[] {
  const merchantIdSet = new Set(selectedMerchantIds);
  const stores = selectedMerchantIds.length
    ? onlinePosList.filter((pos) => merchantIdSet.has(pos.merchantId))
    : onlinePosList;

  return stores.map((pos) => ({
    value: pos.id,
    label: pos.name,
  }));
}
